export const ORDER_STATUS_PHASE = {
	VERIFYING: 'verifying',
	SUCCESS: 'success',
	FAILED: 'failed',
};

export const PAYMENT_FOR = {
	PLAN: 'plan',
	TOKENS: 'tokens',
};

export const ORDER_STATUS_TIMING = {
	POLL_INTERVAL_MS: 3000,
	PAYMENT_VERIFY_TIMEOUT_MS: 120_000,
	SUCCESS_REDIRECT_DELAY_MS: 1500,
};

export const ORDER_STATUS_QUERY_PARAM_KEY = {
	REDIRECT_STATUS: 'redirect_status',
	PAYMENT_INTENT: 'payment_intent',
	SETUP_INTENT: 'setup_intent',
	PAYMENT_FOR: 'paymentFor',
	FROM_QUIZ: 'fromQuiz',
	EMAIL: 'email',
	STUDIO_STATE: 'studioState',
	CHECKOUT_RETURN_URL: 'checkoutReturnUrl',
	RETURN_PATH: 'returnPath',
	RESULT: 'result',
};

export const ORDER_STATUS_QUERY_PARAM_DEFAULT = {
	RETURN_PATH: '/studio',
};
